import React, { createContext, useContext, useState, useEffect } from "react";
import YetiServices from "../services/YetiServices";

const ServicesContext = createContext();

export const ServicesProvider = ({ children }) => {
  const [services, setServices] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const fetchServices = async (filters = {}) => {
    setLoading(true);
    setError("");

    try {
      const response = await YetiServices.serviceList(filters);
      if (response?.data?.results) {
        setServices(response.data.results);
      } else {
        setError("Failed to fetch services. Please try again later.");
      }
    } catch (err) {
      console.error("Error fetching services:", err);
      setError("An error occurred while fetching services.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchServices();
  }, []);

  return (
    <ServicesContext.Provider
      value={{ services, loading, error, fetchServices }}
    >
      {children}
    </ServicesContext.Provider>
  );
};

export const useServices = () => {
  const context = useContext(ServicesContext);
  if (context === undefined) {
    throw new Error("useServices must be used within a ServicesProvider");
  }
  return context;
};
